import { getAnalytics, logEvent } from 'firebase/analytics'
import { FirebaseInstance } from './instance'
import { User } from 'types/user'

FirebaseInstance.initialize()

export class FirebaseAnalytics {
  analytics = getAnalytics()

  /**
   * @description Track page view
   */
  trackPage(to: string, options: { user?: User }) {
    const { user } = options
    logEvent(this.analytics, 'page_view', {
      // page_title: String(to),
      // page_location: String(to),
      page_path: String(to),
      user_id: user?._id,
    })
  }
  trackOpenChatArea(areaId: string, options: { user?: User; type: 'guest' | 'logged' }) {
    const { user, type } = options
    logEvent(this.analytics, 'chat_open', {
      chat_type: type,
      chat_area_id: areaId,
      chat_user_id: user?._id,
    })
  }
}
